module.exports = __webpack_public_path__ + "img/party-2.56242935.jpg";